import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";

export default function RouterPlaceringArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Dit wifi-signal kan blive påvirket af mange ting i dit hjem.
                            Derfor er det vigtigt, at din router bliver placeret rigtigt, så du får den bedst mulige wifi-kvalitet.
                            Hvis routeren står et dårligt sted i din bolig, kan du opleve bl.a. dækningsproblemer eller langsomt wifi.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Der er følgende hovedregler til at placere din router optimalt.
                        </h2>
                    </div>
                    <ul className="list list--number list--image">
                        <li>
                            <p>
                                Placér den i rummet, hvor du bruger internettet mest, eller hvor du ønsker den stærkeste forbindelse.
                            </p>
                        </li>
                        <li>
                            <p>
                                Stil den så højt som muligt.
                            </p>
                        </li>
                        <li>
                            <p>
                                Stil den væk fra elementer, der kan påvirke dit wifi (bl.a. spejl, mikroovn, køleskab, babyalarm).
                            </p>
                        </li>
                        <li>
                            <p>
                                Hvis du har 5G-internet, anbefaler vi at stille routeren i vindueskarmen.
                                Så kan den nemlig nemt fange det udvendige 5G-signal.
                            </p>
                        </li>
                    </ul>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            4 steder du bør <span className="hiper-text-stroke">undgå</span> at placere routeren
                        </h2>
                    </div>
                    <ol className="list list--number list--image">
                        <li className="h3">
                            <h3>Bag sofaen</h3>
                            <p>
                                Møbler kan svække wifi-signalet fra routeren.
                            </p>
                        </li>
                        <li className="h3">
                            <h3>Inde i skabet</h3>
                            <p>
                                Et skab kan blokere for routerens wifi-signal.
                            </p>
                        </li>
                        <li className="h3">
                            <h3>På gulvet</h3>
                            <p>
                                Der står nemlig tit møbler på gulvet, og det kan svække routerens wifi-signal.
                                Dine enheder kan også bedst nå dit wifi-signal, hvis din router er placeret højt.
                            </p>
                        </li>
                        <li className="h3">
                            <h3>I køkkenet eller på badeværelset</h3>
                            <p>
                                Køkkenmaskiner, fugtisolerede vægge og hårde hvidevarer kan nemlig påvirke routerens wifi-signal.
                            </p>
                        </li>
                    </ol>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2 className="heading heading--montserrat heading--medium">
                            Hvad gør jeg, hvis jeg ikke kan placere min router et optimalt sted?
                        </h2>
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Nogle gange sidder din fiberboks eller internetstik i f.eks. kælderen eller soveværelset, hvilket gør det svært at placere routeren centralt i din bolig.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Har du mod på det, kan du føre et LAN-kabel langs et panel, igennem en væg el.lign., og tilslutte routeren til kablet.
                                            Så får du en længere ledning til routeren, og du kan placere den et centralt sted.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Du kan købe et LAN-kabel på op til 30 meter for under 100,- kr. online eller i byggemarkeder.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Kablet skal understøtte 1000 Mbit/s.
                                            Vi anbefaler et kabel af typen CAT5e/CAT6.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Alternativt kan wifi-mesh hjælpe.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Wifi-mesh består typisk af 2-3 enheder.
                                            Hoved-enheden skal tilsluttes din router.
                                            De resterende mesh-enheder kan du stille steder i din bolig, hvor du ønsker bedre wifi-dækning.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Hvad gør jeg, hvis jeg har prøvet alt, og mit wifi stadig driller?
                        </h2>
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Som kunde hos os låner du <Link to={"/hjaelp/udstyr/hvilken-router-foelger-med"}>en router</Link>, som dækker langt de fleste kunders behov.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            I enkelte tilfælde kan det være nødvendigt at købe ekstraudstyr såsom wifi-extendere eller et wifi-mesh-system.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Har du f.eks. mange kvadratmeter, betonvægge eller flere etager, kan ekstraudstyr være nødvendigt for at opnå optimal wifi-dækning.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <p>
                                Vi hører især om gode oplevelser med hele wifi-mesh-systemer fra vores kunder.
                                Vi anbefaler, at du besøger en elektronikforhandler, så du kan få hjælp til at vælge det rigtige udstyr.
                            </p>
                        </ul>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "hvordan-traekker-jeg-1000-mbit",
                        "name": "Hvordan trækker jeg 1.000 Mbit?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    }
                ]}
            />
        </>
    )
}
